import { GamepadManager } from "@babylonjs/core/Gamepads/gamepadManager";
import { GenericGamepad } from "@babylonjs/core/Gamepads/Controllers/genericController";
// import { PoseEnabledController } from "@babylonjs/core/Gamepads/Controllers/poseEnabledController";

import * as PIXI from "pixi.js";

import setDeadZone from "./GamepadDeadZone";
import clampStick from "./GamepadClamping";


export default class Gamepad {

    constructor() {


        createGamepadManager()

        function createGamepadManager() {

            const gamepadManager = new GamepadManager();

            const gamepadConnectedSprite = new PIXI.Sprite.from('./assets/sprites/gamepadConnected.png');
            gamepadConnectedSprite.x = 10;
            gamepadConnectedSprite.y = 10;
            gamepadConnectedSprite.width = 400;
            gamepadConnectedSprite.height = 96;

            const gamepadConnectedSound = new Audio('./assets/audio/fx/gamepadConnected.mp3');

            const gamepadDisconnectedSprite = new PIXI.Sprite.from('./assets/sprites/gamepadDisconnected.png')
            gamepadDisconnectedSprite.x = 10;
            gamepadDisconnectedSprite.y = 10;
            gamepadDisconnectedSprite.width = 400;
            gamepadDisconnectedSprite.height = 96;

            const gamepadDisconnectedSound = new Audio('./assets/audio/fx/gamepadDisconnected.mp3');


            gamepadManager.onGamepadConnectedObservable.add((gamepad, state) => {

                console.log(gamepad);

                // UI Element for Gamepad Connected
                game.pixiContainer.addChild(gamepadConnectedSprite);
                gamepadConnectedSound.play();

                // Make UI Disappear
                setTimeout(() => {
                    game.pixiContainer.removeChild(gamepadConnectedSprite);
                }, 1500);

                gamepad.onButtonDownObservable.add((button, state) => {
                    if (button === 0) { console.log(button) }           // Cross
                    else if (button === 1) { console.log(button) }      // Circle
                    else if (button === 2) { console.log(button) }      // Square
                    else if (button === 3) { console.log(button) }      // Triangle
                    else if (button === 4) { console.log(button) }      // L1
                    else if (button === 5) { console.log(button) }      // R1
                    else if (button === 6) { console.log(button) }      // L2
                    else if (button === 7) { console.log(button) }      // R2
                    else if (button === 8) { console.log(button) }      // Share
                    else if (button === 9) { console.log(button) }      // Options
                    else if (button === 10) { console.log(button) }     // L3
                    else if (button === 11) { console.log(button) }     // R3
                    else if (button === 12) { console.log(button) }     // D-PAD UP
                    else if (button === 13) { console.log(button) }     // D-PAD DOWN
                    else if (button === 14) { console.log(button) }     // D-PAD LEFT
                    else if (button === 15) { console.log(button) }     // D-PAD RIGHT
                    else if (button === 16) { console.log(button) }     // PS Button
                    else if (button === 17) { console.log(button) }     // Touchpad Button
                });

                gamepad.onleftstickchanged((values) => {
                    let x = values.x;
                    let y = values.y;

                    x = setDeadZone(x);
                    y = setDeadZone(y);

                    [x, y] = clampStick(x, y);

                });

                gamepad.onrightstickchanged((values) => {
                    let x = values.x;
                    let y = values.y;

                    x = setDeadZone(x);
                    y = setDeadZone(y);

                    [x, y] = clampStick(x, y);

                });

            });

            // Gamepad Disconnected
            gamepadManager.onGamepadDisconnectedObservable.add((gamepad, state) => {

                // UI Element for Gamepad Disconnected
                game.pixiContainer.addChild(gamepadDisconnectedSprite);
                gamepadDisconnectedSound.play();

                // Make UI Disappear
                setTimeout(() => {
                    game.pixiContainer.removeChild(gamepadDisconnectedSprite);
                }, 1500);

            });

        }
    }
}